import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import { SubscriptionsOutlined } from '../../../../node_modules/@material-ui/icons/index';
import { get_DIF_STATUS_apx } from '../../../apiCalls/MainFormRequests';
import {
  getDIFData,
  getEntrySummaryForm,
} from '../../../CBSA_App/api/getEntrySummaryData';
import DocumentImageServicesChooser from './DocumentImageServicesChooser';
const DifStatus = (props) => {
  const [merchandiseData, setMerchandiseData] = useState([]);
  const [B3Data, setb3Data] = useState({});
  const [difStatusData, setDifStatusData] = useState([]);
  const [difFields, setDifFields] = useState([]);
  const [disData, setDisData] = useState([]);
  const [showDisYes, setshowdisyes] = useState(false);
  const [DifData, setDifData] = useState([]);
  const [itemValue, setItemValue] = useState({});
  const getData2ByMerchId = (merchId, data2) => {
    return data2.find((item) => item.merchId == merchId)?.data;
  };

  const getResult = (data1, data2) => {
    let result = [];

    for (let i = 0; i < data1.length; i++) {
      let newData = getData2ByMerchId(data1[i].merchId, data2);
      let newData1 = data1[i].data;
      if (Array.isArray(newData1) && Array.isArray(newData)) {
        for (let j = 0; j < newData1.length; j++) {
          let finalData = newData.find((i) => i.docType == newData1[j].docType);
          result.push({
            merchId: data1[i].merchId,
            docType: newData1[j].docType,
            identifier: finalData.difParams[0]?.identifier,
            statusCode: newData1[j].statusCode,
            pga: finalData.difParams[0]?.pga,
            pgaSubProgramType: finalData.difParams[0]?.pgaSubProgramType,
          });
        }
      }
    }
    return result;
  };

  useEffect(() => {
    getEntrySummaryForm(window.shipmentId, 'normal').then((res) => {
      // console.log('resresres',res.data.eventMessage, res.data.eventMessage?.descriptionOfMerchandise?.merchandiseLineItems);
      setb3Data(res.data.eventMessage);
      setMerchandiseData(
        res.data.eventMessage?.descriptionOfMerchandise?.merchandiseLineItems
      );
    });
  }, []);
  useEffect(() => {
    if (!!merchandiseData.length) {
      let result = [];
      for (let i = 0; i < merchandiseData.length; i++) {
let pgas = merchandiseData[i]?.pgaDetails?.pgaDetails || []
       

            Promise.all(
              pgas.map((item, index) => {
                return get_DIF_STATUS_apx(
                  window.shipmentId,
                  merchandiseData[i]?.merchandiseId +
                    item?.pga?.cbsaPgaSubProgramType
                );
              })
            )
            .then((contents) => {
              let a = {};
              a['merchId'] = merchandiseData[i]?.merchandiseId;
              contents.map((res, i) => {
                if(res.data.eventMessage.difStatus){
                  if (a['data']) {
                    a['data'].push(res.data.eventMessage?.difStatus?.[0]);
                  } else {
                    a['data'] = res.data.eventMessage?.difStatus;
                  }
                }                
              });
              result.push(a);
              setDifStatusData(result);
            });
       
      }
      
    }
  }, [JSON.stringify(merchandiseData)]);

  useEffect(() => {
    if (!!merchandiseData.length) {
      let result = [];
      for (let i = 0; i < merchandiseData.length; i++) {
       let pgas = merchandiseData[i]?.pgaDetails?.pgaDetails || []
       
       Promise.all(
        pgas.map((item, index) => {
          return getDIFData(
            merchandiseData[i]?.merchandiseId +
              item?.pga?.cbsaPgaSubProgramType
          );
        })
      )
      .then((contents) => {
        let a = {};
        a['merchId'] = merchandiseData[i]?.merchandiseId;
        contents.map((res, i) => {
          if(res.data.eventMessage?.difFields){
            if (a['data']) {
              a['data'].push(res.data.eventMessage?.difFields?.[0]);
            } else {
              a['data'] = res.data.eventMessage?.difFields;
            }
          }
        });
        result.push(a);
          setDifFields(result);
      });
      
      }
      
    }
  }, [JSON.stringify(merchandiseData)]);
  useEffect(() => {
    if (!!difFields.length && !!difStatusData.length) {
      let finalResult = getResult(difStatusData, difFields);
      setDisData(finalResult);
    }
  }, [JSON.stringify(difFields), JSON.stringify(difStatusData)]);

  const importer = useSelector((state) => state?.Importer?.importer);
  const getDIF = (mrchID) => {
    // setloader(true);
    getDIFData(mrchID).then((response) => {
      const Data = response.data.eventMessage;
      if (Object.keys(Data).length === 0) {
        setDifData([]);
        // setloader(false);
      } else {
        let difData = [];
        Data.difFields.map((difField, i) => {
          difField.difParams.map((difObj) => {
            if (Object.keys(difObj).length == 3) {
              difData.push({
                lpcoNum: `${difObj.lpcoReferenceNumber.toUpperCase()}`,
                lpcoDocType: `${difObj.lpcoImageTypeCode.toUpperCase()}`,
                imageURN: `${difObj.identifier.toUpperCase()}`,
              });
            }
          });
        });
        convertAndSaveDIFValues(difData);
        setDifData(difData);
        // setloader(false);
      }
    });
  };

  const getDIFOnCLose = (mrchID) => {
    // setloader(true);
    getDIFData(mrchID).then((response) => {
      const Data = response.data.eventMessage;
      if (Object.keys(Data).length === 0) {
        setDifData([]);
      } else {
        let difData = [];
        Data.difFields.map((difField, i) => {
          difField.difParams.map((difObj) => {
            difData.push({
              lpcoNum: `${difObj.lpcoReferenceNumber.toUpperCase()}`,
              lpcoDocType: `${difObj.lpcoImageTypeCode.toUpperCase()}`,
              imageURN: difObj.identifier
                ? `${difObj.identifier.toUpperCase()}`
                : 'URN Missing',
            });
          });
        });
        const difDataFinal = convertAndSaveDIFValues(difData);
        // props.setDifDataforPga(difDataFinal);
        setDifData(difData);

        // props.handleSaveAfterDIF(difDataFinal);
        // setloader(false);
      }
    });
  };
  const convertAndSaveDIFValues = (difData) => {
    let lpcoNum = [],
      lpcoDocType = [],
      imageURN = [],
      finalObj = {};

    for (let i = 0; i < difData.length; i++) {
      lpcoNum.push({
        id: i,
        value: `${difData[i].lpcoNum}` || '',
      });
      lpcoDocType.push({
        id: i,
        value: `${difData[i].lpcoDocType}` || '',
      });
      imageURN.push({
        id: i,
        value: `${difData[i].imageURN}` || '',
      });
    }
    finalObj = {
      lpcoNum: lpcoNum,
      lpcoDocType: lpcoDocType,
      imageURN: imageURN,
    };
    // props.setDifDataforPga(finalObj);
    return finalObj;
  };
  return (
    <>
      {!!disData.length ? (
        <div
          style={{
            zIndex: 1000,
            width: 500,
            padding: 20,
            backgroundColor: '#fff',
            border: '2px solid green',
          }}
        >
          <ul>
            <li>
              {disData.map((item) => (
                <>
                  <h6
                    style={{ cursor: 'pointer', marginTop: 5 }}
                    onClick={() => {
                      if (item.pga && item.identifier) {
                        setItemValue(item);
                        setshowdisyes(true);
                      } else {
                        alert("seems it's an older DIF filing");
                      }
                    }}
                  >
                    Line{' '}
                    {`${
                      merchandiseData.findIndex(
                        (i) => i.merchandiseId == item.merchId
                      ) + 1
                    }`}{' '}
                    : {item.statusCode == 200 ? 'success' : 'Failed'} | PGA :{' '}
                    {item.pga ? item.pga : "seems it's an older DIF filing"} |
                    URN :{' '}
                    {item.identifier
                      ? item.identifier
                      : "seems it's an older DIF filing"}
                  </h6>
                </>
              ))}
            </li>
          </ul>
        </div>
      ) : (
        <span>
          <Loader active inline size='mini' style={{ marginRight: '10px' }} />
        </span>
      )}
      {!!showDisYes && (
        <DocumentImageServicesChooser
          pgaAutomation={true
            // ['HC', 'GAC',"ECCC","CFIA"].includes(itemValue.pga) ||
            // ['Agriculture'].includes(itemValue.pgaSubProgramType)
            //   ? true
            //   : false
          }
          kxUser={props.kxUser}
          modalrequestid={itemValue.merchId}
          closefunc={() => {
            setshowdisyes(false);
            getDIFOnCLose(
              itemValue.merchId + itemValue.pgaSubProgramType || ''
            );
          }}
          pgaType={itemValue.pga || ''}
          pgaSubType={itemValue.pgaSubProgramType || ''}
          shipId={window.shipmentId}
          shipmentCountry={'CA'}
          importer={importer}
          getmaterialisedlpcodata={() => {
            getDIF(itemValue.merchId);
          }}
        />
      )}
    </>
  );
};

export default DifStatus;
